import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Card,
    Typography,
    Link,
    IconButton,
    Collapse
} from '@mui/material';
import { Close, ExpandMore, ExpandLess } from '@mui/icons-material';
import { initGA } from '../utils/analytics';

const CookieConsent: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem('cookieConsent', 'all');
        setIsVisible(false);
        initGA();
    };

    const handleAcceptEssential = () => {
        localStorage.setItem('cookieConsent', 'essential');
        setIsVisible(false);
    };

    const handleClose = () => {
        localStorage.setItem('cookieConsent', 'essential');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                p: 2,
                //bgcolor: 'rgba(0, 0, 0, 0.8)',
                backdropFilter: 'blur(8px)'
            }}
        >
            <Card
                sx={{
                    maxWidth: '6xl',
                    mx: 'auto',
                    p: 3,
                    borderRadius: 4,
                    boxShadow: 6,
                    background: 'linear-gradient(135deg, rgba(250,250,255,0.95) 0%, rgba(230,240,255,0.85) 100%)',
                    border: '1px solid rgba(180,200,255,0.25)',
                    backdropFilter: 'blur(12px)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" gutterBottom>
                            We use cookies
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            We use cookies to enhance your browsing experience, analyse site traffic, and personalise content.
                            By clicking "Accept All", you consent to our use of cookies.
                        </Typography>

                        <Collapse in={isExpanded}>
                            <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Cookie Categories:
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                    <strong>Essential:</strong> Required for basic site functionality
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                    <strong>Analytics:</strong> Help us understand how you use our site
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Marketing:</strong> Used to show you relevant advertisements
                                </Typography>
                            </Box>
                        </Collapse>

                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAcceptAll}
                                size="small"
                            >
                                Accept All
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={handleAcceptEssential}
                                size="small"
                            >
                                Essential Only
                            </Button>
                            <Button
                                variant="text"
                                onClick={() => setIsExpanded(!isExpanded)}
                                size="small"
                                endIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
                            >
                                {isExpanded ? 'Less' : 'More'} Info
                            </Button>
                            <Link
                                href="/cookie-policy"
                                variant="body2"
                                color="primary"
                                underline="hover"
                            >
                                Cookie Policy
                            </Link>
                        </Box>
                    </Box>

                    <IconButton
                        onClick={handleClose}
                        size="small"
                        sx={{ color: 'text.secondary' }}
                    >
                        <Close />
                    </IconButton>
                </Box>
            </Card>
        </Box>
    );
};

export default CookieConsent;